module.exports = __webpack_public_path__ + "b98e64e130fd5ea22de2697bd8e5df9e.jpg";